import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

export interface SccDiseaseSelection {
  code: string;        // "ED", "HD", "AS", etc.
  name: string;        // "Dysplasie du coude", etc.
  selected: boolean;
  available: boolean;  // Present in the original study
}

export interface SccDiseasesSelectionResult {
  selectedDiseases: string[]; // ["ED", "HD"]
}

@Component({
  selector: 'app-scc-select-diseases-popup',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    FormsModule
  ],
  templateUrl: './scc-select-diseases-popup.component.html',
  styleUrl: './scc-select-diseases-popup.component.scss'
})
export class SccSelectDiseasesPopupComponent implements OnInit, IDialogContentComponent<SccDiseasesSelectionResult, SccDiseaseSelection[]> {
  input?: SccDiseaseSelection[];
  diseases: SccDiseaseSelection[] = [];

  ngOnInit(): void {
    if (this.input) {
      this.diseases = [...this.input];
    }
  }

  getSelectedCount(): number {
    return this.diseases.filter(d => d.selected).length;
  }

  canConfirm(): boolean {
    return this.getSelectedCount() > 0;
  }

  // Implémentation de IDialogContentComponent
  getResult(): SccDiseasesSelectionResult {
    return {
      selectedDiseases: this.diseases
        .filter(d => d.selected)
        .map(d => d.code)
    };
  }

  isDisabled(): boolean {
    return !this.canConfirm();
  }

  onCancel(): void {
    // La fermeture est gérée par le ModalDialogService
  }

  onConfirm(): void {
    // La validation et fermeture sont gérées par le ModalDialogService
  }
}
